import React, { useState, useEffect, useRef } from "react";
import { ARROWS_DISTANCE, CIRCLE_SIZE, ENABLE_APARTMENT_TOUR, LINE_COLOR, LINE_START, LINE_WIDTH, MAX_DISTANCE, MODEL_NAME, PODIUM_SCALE, RESIZE_MODEL, ROTATE_FLOORS, ROTATE_MODEL, SHOW_INITIAL_ANIMATION, SHOW_OCEAN, TRANSPARENCY, X, Y, Z } from "../../constants";
import Input from "./Input";
import { defaultSettings } from "./defaultSettings";
import BasicSettingComponent from "./BasicSettingsComponent";


const Settings = ({
  projectDefaultView,
  buildings,
  projectModels,
  saveStatus,
  onChange,
  saveProject,
  saveViewData,
  resetViewData,
  setSelectedModelId,
  selectedBuildingName,
  selectedModelId
}) => {
    console.log("projectModels", projectModels);
    console.log("buildings", buildings);
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [form, setForm] = useState(defaultSettings)
  const updatedSettings = useRef(defaultSettings);
  const selectedBuilding = buildings.find(
    (building) => building.name === selectedBuildingName
  );
  useEffect(() => {
    const newForm = { ...form };
    console.log("seTTINGS", {projectDefaultView})
    if (projectDefaultView) {
      updateProjectSettings(newForm, projectDefaultView);
    }
    if (selectedBuilding && selectedBuilding.default_view) {
      updateBuildingSettings(newForm, selectedBuilding);
    }
    setForm(newForm);
    updatedSettings.current = newForm;
  
    return () => {
      
    }
  }, [selectedBuildingName, buildings, projectDefaultView])
  const updateProjectSettings = (newForm, projectDefaultView) => {
    newForm.Project.forEach((setting) => {
      if (projectDefaultView[setting.property] !== undefined) {
        setting.value = projectDefaultView[setting.property];
      }
    });

 };
  
  const updateBuildingSettings = (newForm, selectedBuilding) => {

    if (selectedBuilding.default_view.position) {
      if (selectedBuilding.default_view.position.x)
        newForm.Buildings.find((setting) => setting.label === X).value = selectedBuilding.default_view.position.x;
      if (selectedBuilding.default_view.position.z)
        newForm.Buildings.find((setting) => setting.label === Z).value = selectedBuilding.default_view.position.z;
    }
    if (selectedBuilding.default_view.scale)
      newForm.Buildings.find((setting) => setting.label === RESIZE_MODEL).value = selectedBuilding.default_view.scale.x;
    if (selectedBuilding.default_view.rotation && selectedBuilding.default_view.rotation._y)
      newForm.Buildings.find((setting) => setting.label === ROTATE_MODEL).value = selectedBuilding.default_view.rotation._y;
    if (selectedBuilding.default_view.circleRadiusOffset)
      newForm.Buildings.find((setting) => setting.label === CIRCLE_SIZE).value = selectedBuilding.default_view.circleRadiusOffset;
  };
  const tabs = Object.keys(form);
  const onTabChange = (index, tabName) => {

    if (activeTabIndex !== index) {
      setActiveTabIndex(index);
    }
  };
  const handleOnChange = (e, tab) => {
    console.log(e)
    const { label, value } = e;
    console.log({ label, value, tab })
    const newForm = { ...updatedSettings.current };
    newForm[tab].find((setting) => setting.label === label).value = value;
    // setForm(newForm);
    updatedSettings.current = newForm;
    onChange(e, tab);
  }
  const BuildingsSettings = ({
    settings,
    selectedBuildingName
  }) => {
    function handleBuildingSelectChange(event) {
      // console.log(buildings)
      setSelectedModelId(event.target.value);
    }
    const selectedBuilding = buildings.find(
      (building) => building.id === selectedModelId
    );
    if (selectedBuilding && selectedBuilding.default_view) {
      settings = settings.map(setting => {
        if (setting.label === X && selectedBuilding.default_view.position)
          setting.value = selectedBuilding.default_view.position.x;
        if (setting.label === Y && selectedBuilding.default_view.position)
          setting.value = selectedBuilding.default_view.position.y;
        if (setting.label === Z && selectedBuilding.default_view.position)
          setting.value = selectedBuilding.default_view.position.z;
        if (setting.label === RESIZE_MODEL && selectedBuilding.default_view.scale)
          setting.value = selectedBuilding.default_view.scale.x;
        if (setting.label === ROTATE_MODEL && selectedBuilding.default_view.rotation)
          setting.value = selectedBuilding.default_view.rotation._y;
        if (setting.label === CIRCLE_SIZE && selectedBuilding.default_view.circleRadiusOffset)
          setting.value = selectedBuilding.default_view.circleRadiusOffset;
        return setting;
      });
    }
    // console.log({ selectedBuildingName });
    return (
      <div>
        <select value={selectedModelId} onChange={handleBuildingSelectChange}>
        <option value={null}>
          Select building
              </option>
          {buildings.map((building, i) => {
            return (
              <option key={i} value={building.id}>
                {building.name}
              </option>
            );
          })}
        </select>
        {/* <button onClick={() => saveViewData("building")}>
          Save building view
        </button> */}
        {selectedBuilding && settings.map((setting, i) => {
          return <Input key={i} {...setting} onChange={(value) => handleOnChange({
            label: setting.label,
            value
          }, "Buildings")} />;
        })}
        {selectedBuilding && <button
          className={saveStatus === "Save" ? "bgGreen" : "bgRed disabled"}
          onClick={() => saveViewData("building-floors")}
        >
          Save floors view
        </button>}
        {selectedBuilding && <button
          className={saveStatus == "Save" ? "bgGreen" : "bgRed disabled"}
          onClick={() => saveViewData("building")}
        >
          {saveStatus}
        </button>}
        {/* <button onClick={() => saveViewData("building")}>
          Reset
        </button> */}
      </div>
    );
  };
  const ModelsSettings = ({
    settings,
    selectedBuildingName
  }) => {
    function handleBuildingSelectChange(event) {
      // console.log(buildings)
      setSelectedModelId(event.target.value);
    }
    const selectedModel = projectModels.find(
      (model) => model.id === selectedModelId
    );
    // console.log({ selectedBuildingName });
    console.log("selectedModel", selectedModel, {settings});
    settings = settings.map(setting => {
      if (selectedModel && selectedModel.default_view) {
        if (setting.label === MODEL_NAME && selectedModel.default_view.modelName)
          setting.value = selectedModel.default_view.modelName;
        if (setting.label === X && selectedModel.default_view.position)
          setting.value = selectedModel.default_view.position.x;
        if (setting.label === Y && selectedModel.default_view.position)
          setting.value = selectedModel.default_view.position.y;
        if (setting.label === Z && selectedModel.default_view.position)
          setting.value = selectedModel.default_view.position.z;
        if (setting.label === RESIZE_MODEL && selectedModel.default_view.scale)
          setting.value = selectedModel.default_view.scale.x;
        if (setting.label === ROTATE_MODEL && selectedModel.default_view.rotation)
          setting.value = selectedModel.default_view.rotation._y;
      }
      return setting;
    });
    return (
      <div>
        <select value={selectedModelId} onChange={handleBuildingSelectChange}>
        <option value={null}>
          Select model
              </option>
          {projectModels.map((model, i) => {
            return (
              <option key={i} value={model.id}>
                {model.default_view.modelName ? model.default_view.modelName : model.id}
              </option>
            );
          })}
        </select>
        {/* <button onClick={() => saveViewData("building")}>
          Save building view
        </button> */}
        {selectedModel && settings.map((setting, i) => {
          return <Input key={i} 
            {...setting} 
            value={setting.value}
            onChange={(value) => handleOnChange({
            label: setting.label,
            value
          }, "Models")} />;
        })}
        {selectedModel && <div>
            <button
            className={saveStatus === "Save" ? "bgGreen" : "bgRed disabled"}
            onClick={() => saveViewData("model_view")}
          >
            Save model view
          </button>
          <button
          className={saveStatus == "Save" ? "bgGreen" : "bgRed disabled"}
          onClick={() => saveViewData("model")}
        >
          {saveStatus}
        </button>
          <button
          className={saveStatus == "Save" ? "bgRed" : "bgRed disabled"}
          onClick={() => resetViewData("model")}
        >
          Reset
        </button>
          </div>
        }

      </div>
    );
  };

  
  
  // const FloorsSettings = () => {

  //   // console.log({ selectedBuildingName });
  //   return (
  //     <div>

  //       {form.Floors.map((setting, i) => {
  //         return <Input key={i} {...setting} onChange={value => handleOnChange({
  //           label: setting.label,
  //           value
  //         }, "Floors")} />;
  //       })}
  //       <button
  //         className={saveStatus == "Save" ? "bgGreen" : "bgRed disabled"}
  //         onClick={() => saveProject(updatedSettings.current)}
  //       >
  //         {saveStatus}
  //       </button>

  //     </div>
  //   );
  // };
  // const Settings360 = () => {

  //   // console.log({ selectedBuildingName });
  //   return (
  //     <div>

  //       {form.View360.map((setting, i) => {
  //         return <Input key={i} {...setting} onChange={value => handleOnChange({
  //           label: setting.label,
  //           value
  //         }, "View360")} />;
  //       })}
  //       <button
  //         className={saveStatus == "Save" ? "bgGreen" : "bgRed disabled"}
  //         onClick={() => saveProject(updatedSettings.current)}
  //       >
  //         {saveStatus}
  //       </button>

  //     </div>
  //   );
  // };
  const ProjectSettings = () => {
    return (
      <div>
        <button onClick={() => saveViewData("project")}>
          Save project view
        </button>
        <BasicSettingComponent
          name="Project"
          settings={form.Project}
          handleOnChange={handleOnChange}
          saveStatus={saveStatus}
          onSave={() => saveProject(updatedSettings.current)}
        />
        {/* {form.Project.map((setting, i) => {
          return <Input key={i} {...setting} onChange={(value) => handleOnChange({
            label: setting.label,
            value
          }, 'Project')} />;
        })}
        <div>
        <button
          className={saveStatus == "Save" ? "bgGreen" : "bgRed disabled"}
          onClick={() => saveProject(updatedSettings.current)}
        >
          {saveStatus}
        </button>
      </div> */}
      </div>
    );
  };
  const TilesSettings = () => {
    return (
      <div>

        {form.Tiles.map((setting, i) => {
          return <Input key={i} {...setting} onChange={(value) => handleOnChange({
            label: setting.label,
            value
          }, 'Tiles')} />;
        })}
        <div>
        <button
          className={saveStatus == "Save" ? "bgGreen" : "bgRed disabled"}
          onClick={() => saveProject(updatedSettings.current)}
        >
          {saveStatus}
        </button>
      </div>
      </div>
    );
  };
  const Tabs = ({ tabs, activeTab, onTabChange }) => {
    return (
      <div
        className="tabs"
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "20px",
          gap: "20px",
        }}
      >
        {tabs.map((tab, i) => {
          return (
            <div
              key={i}
              className={activeTab === i ? "active" : ""}
              onClick={() => onTabChange(i, tab)}
            >
              {tab}
            </div>
          );
        })}
      </div>
    );
  };
  const TabContent = ({ activeTabIndex, settings,selectedBuildingName }) => {
    switch (activeTabIndex) {
      case 0:
        
        return <ProjectSettings />;
      case 1:
        return <BuildingsSettings settings={settings.Buildings} selectedBuildingName={selectedBuildingName}/>;
      case 2:
        return <BasicSettingComponent 
          name="View360"
          settings={settings.View360}
          handleOnChange={handleOnChange}
          saveStatus={saveStatus}
          onSave={() => saveProject(updatedSettings.current)}
        />;
      // case 3:
      //   return <TilesSettings />;
      case 3:
        return <BasicSettingComponent 
        name="Floors"
        settings={settings.Floors}
        handleOnChange={handleOnChange}
        saveStatus={saveStatus}
        onSave={() => saveProject(updatedSettings.current)}
      />;
      case 4:
        return <ModelsSettings 
        name="Models"
        settings={settings.Models}
        handleOnChange={handleOnChange}
        saveStatus={saveStatus}
        onSave={() => saveProject(updatedSettings.current)}
      />;
      
    
      default:
        return <div>Tab content</div>;
        // break;
    }
  }
  return (
    <div className="p-2">
      <Tabs tabs={tabs} activeTab={activeTabIndex} onTabChange={onTabChange} />
      <TabContent activeTabIndex={activeTabIndex} settings={form} selectedBuildingName={selectedBuildingName}/>
    </div>
  );
};


export default Settings;
